import {catchError, map, mergeMap} from 'rxjs/operators';
import {Observable, of, ReplaySubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {FeatureApi} from '../api/rest/feature.restapi';
import {Feature, FeatureId, FeatureMap} from '@webmate-web-core/shared/types/feature';

;

;

/**
 * Provide access to customer features.
 */
@Injectable({
    providedIn: 'root'
})
export class FeatureService {

    private _features: ReplaySubject<FeatureMap> = new ReplaySubject<FeatureMap>(1);

    constructor(private featureApi: FeatureApi, private OAuth2AuthService: AuthService) {
        this.OAuth2AuthService.observeAuthStatus().pipe(mergeMap(auth => {
            if (auth) {
                return this.featureApi.getFeaturesForUser();
            } else {
                return of(undefined);
            }
        })).subscribe(features => {
                if (!!features) {
                    this._features.next(features);
                }
            },
            error => console.warn('Could not request features: ' + error)
        );
    }

    refreshFeatures() {
        this.featureApi.getFeaturesForUser().subscribe(f => {
            if (f) {
                this._features.next(f);
            }
        })
    }

    /** Get single feature specified by name. */
    getFeature(featureName: FeatureId): Observable<Feature> {
        return this._features.pipe(map(features => {
            return features[featureName];
        }));
    }

    /**
     * Resolve a feature through an independent catalog request. Request failures emit undefined so
     * bootstrap callers can fail closed without changing existing feature consumers.
     */
    resolveFeature(featureName: FeatureId): Observable<Feature | undefined> {
        return this.featureApi.getFeaturesForUser().pipe(
            map(features => features[featureName]),
            catchError(error => {
                console.warn('Could not resolve feature ' + featureName + ': ' + error);
                return of(undefined);
            })
        );
    }

    getFeatures(featureNames: FeatureId[]): Observable<Feature[]> {
        return this._features.pipe(map(features => {
            return featureNames.map(featureName => features[featureName]);
        }));
    }
}
